import get from 'lodash.get';
import { config } from '@yola/ws-sdk';

const getHcaptchaSiteKey = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);

  return get(cfg, 'common.hcaptcha.user_sites.site_key');
};

export default getHcaptchaSiteKey;
